// extracted by mini-css-extract-plugin
module.exports = {"button":"LoginMethodSelector_button__3HIx3","icon":"LoginMethodSelector_icon__2eyaL"};